import { wsClient, wsClientAuth } from './client';

type HistroyParams = {
  resolution?: number | string;
  symbol: string;
  from?: number;
  to?: number;
  quote?: number;
  compress?: number;
};

/**
 * @param {number | string} resolution 即時(1) / 分(5) /日(D) / 週(W) / 月(M)
 * @param {string} symbol 台股(TWS:0050:STOCK) / 台股興櫃(TWG:1260:STOCK) / 台股指數(TWS:TSE01:INDEX) / 陸股(CNS:601318:STOCK) / 港股(HKS:0700:STOCK) / 美股(USS:GOOGL:STOCK) / 國際指數(GI:SP500 ) / 期貨(GI:DJCIBR) / 外匯(FX:USDTWD)
 * @param {number} from timestamp
 * @param {number} to timestamp
 * @param {number} quote api response include quote data or not
 * @param {bool} compress compress
 * @returns {Promise}
 */
export const GETv1HistoryBySymbol = ({ resolution = 5, symbol, from, to, quote = 0, compress }: HistroyParams) => {
  const url = '/ws/api/v1/charting/history';
  const params: HistroyParams = {
    symbol,
    quote,
    resolution
  };

  if (from) params.from = from;
  if (to) params.to = to;
  if (compress) params.compress = compress;

  return wsClient.get(url, params);
};

/**
 * 與v1相同，新增打API需要token
 * @param param
 * @returns
 */
export const GETv4HistoryBySymbol = async ({
  resolution = 5,
  symbol,
  from,
  to,
  quote = 0,
  compress
}: HistroyParams) => {
  const url = '/ws/api/v4/charting/history';
  const params: HistroyParams = {
    symbol,
    quote,
    resolution
  };

  if (from) params.from = from;
  if (to) params.to = to;
  if (compress) params.compress = compress;

  return await wsClientAuth.get(url, params);
};

/**
 * 很多不同種類的列表都是由這個api來拿到(使用不同type)。e.g. 看看外匯、看看國際
 * @param params
 * @returns
 */
export const GETv2Quote = (params: { type?: string; column?: string; limit?: number }, options?: any) => {
  const url = '/ws/api/v2/universal/quote';

  return wsClient.get(url, params, options);
};

/**
 * 回傳symbol基本資訊(中文名稱/今日漲跌幅)
 * @param symbol
 * @returns
 */
export const GETv2QuoteBySymbol = (symbol: string, params?: { column?: string }) => {
  const url = `/ws/api/v2/quote/quotes/${symbol}`;

  return wsClient.get(url, params);
};
